module.exports = __webpack_public_path__ + "static/img/default-logo.4b67ecf3.jpg";